import {Button} from '@/components/ui/button/Button'
import {FC, useState} from 'react'
import {StyledNotFoundContainer, StyledRoot} from './style'
import {useNavigate} from 'react-router-dom'
import {Trans, useTranslation} from 'react-i18next'
import {ROUTE_HOME} from '@/utilities/constants/routeNames'
import {ArrowRightIcon, NotFoundIcon} from '@/assets/icons/icons'
import i18next from 'i18next'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ContactUsModal} from '@/features/contact-us/components/contact-us-modal/ContactUsModal'

export const NotFound: FC = () => {
    const navigate = useNavigate()
    const {t} = useTranslation()
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false)

    return (
        <StyledRoot>
            <StyledNotFoundContainer justify="center" direction="column" align="center" gap={6}>
                <NotFoundIcon />
                <h3>{t('not_found:title')}</h3>

                <p>
                    <Trans t={t} i18nKey="not_found:message" />
                </p>

                <Flexbox fullWidth gap={4} align="center" justify="center">
                    <Button variant="primary" onClick={() => setIsContactUsModalOpen(true)}>
                        {i18next.t('commons:contact_us')}
                    </Button>
                    <Button onClick={() => navigate(ROUTE_HOME)}>
                        {t('not_found:cta')} <ArrowRightIcon height={16} />
                    </Button>
                </Flexbox>
            </StyledNotFoundContainer>
            {isContactUsModalOpen && <ContactUsModal onClose={() => setIsContactUsModalOpen(false)} />}
        </StyledRoot>
    )
}
NotFound.displayName = 'NotFound'
